import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-list-item',
  templateUrl: './loading-list-item.component.html',
  styleUrls: ['./loading-list-item.component.css']
})
export class LoadingListItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
